import React, { useEffect, useState } from "react";
import { CPInput } from "./CPInput";
import { CrewPilotModuleShell } from "./CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../layout/pageLayout";
import "./admin/adminDesktop.css";
import {
  acceptOrganizationInvitation,
  clearInviteTokenFromLocation,
  joinOrganizationByCode,
  normalizeJoinCode,
  parseInviteTokenFromLocation,
  resolveJoinCode,
} from "../helpers/membershipInvitations";

export function OrganizationJoinScreen({
  onBack,
  onComplete,
  initialInviteToken = null,
}) {
  const [inviteToken, setInviteToken] = useState(initialInviteToken || "");
  const [joinCode, setJoinCode] = useState("");
  const [resolvedOrgName, setResolvedOrgName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const fromUrl = parseInviteTokenFromLocation();
    if (fromUrl) {
      setInviteToken(fromUrl);
    }
  }, []);

  const handleResolveCode = async () => {
    setError(null);
    setResolvedOrgName("");
    try {
      const result = await resolveJoinCode(joinCode);
      setResolvedOrgName(result?.organization_name || "Organization");
    } catch (err) {
      setError(err.message || "Join code not found.");
    }
  };

  const handleAcceptInvite = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const result = await acceptOrganizationInvitation(inviteToken);
      setSuccess(
        `Joined ${result?.organization_name || "organization"} as ${result?.role}.`,
      );
      clearInviteTokenFromLocation();
      onComplete?.(result);
    } catch (err) {
      setError(err.message || "Unable to accept invitation.");
    } finally {
      setLoading(false);
    }
  };

  const handleJoinByCode = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const result = await joinOrganizationByCode(joinCode);
      setSuccess(
        `Joined ${result?.organization_name || "organization"} as employee.`,
      );
      onComplete?.(result);
    } catch (err) {
      setError(err.message || "Unable to join organization.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CrewPilotModuleShell
      title="Join Organization"
      subtitle="Accept an invitation or enter a join code"
      sectionLabel="Membership"
      onBack={onBack}
      layout={PAGE_LAYOUT.FORM}
    >
      <div className="adm-scope">
      <div className="adm-split adm-split--auto">
      <div className="rb-card">
        <div className="section-heading">INVITATION TOKEN</div>
        <CPInput
          label="Invitation token"
          value={inviteToken}
          onChange={setInviteToken}
          placeholder="Paste token from invitation link"
        />
        <button
          type="button"
          className="kpi-back-btn adm-primary"
          onClick={handleAcceptInvite}
          disabled={loading || !inviteToken.trim()}
        >
          {loading ? "Working…" : "Accept invitation"}
        </button>
      </div>

      <div className="rb-card" style={{ marginTop: "16px" }}>
        <div className="section-heading">JOIN CODE</div>
        <CPInput
          label="Organization join code"
          value={joinCode}
          onChange={(value) => setJoinCode(normalizeJoinCode(value))}
          placeholder="e.g. CREW7X2K"
        />
        <button
          type="button"
          className="kpi-back-btn"
          style={{ marginTop: "8px" }}
          onClick={handleResolveCode}
          disabled={!joinCode.trim()}
        >
          Look up code
        </button>
        {resolvedOrgName && (
          <p className="profile-value" style={{ marginTop: "10px" }}>
            Organization: {resolvedOrgName}
          </p>
        )}
        <button
          type="button"
          className="kpi-back-btn adm-primary"
          style={{ marginTop: "8px" }}
          onClick={handleJoinByCode}
          disabled={loading || !joinCode.trim()}
        >
          {loading ? "Joining…" : "Join as employee"}
        </button>
      </div>

      </div>
      {error && <p className="admin-placeholder-note adm-join-msg">{error}</p>}
      {success && <p className="admin-save-confirmation adm-join-msg">{success}</p>}
      </div>
    </CrewPilotModuleShell>
  );
}
